import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Florida.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Revolutionizing Florida Enterprises with Tailored Software
              Solutions
            </h2>
            <p>
              At TekRevol, we're committed to revolutionizing enterprises across
              the Sunshine State with bespoke software solutions that redefine
              how business is conducted.
            </p>
            <p>
              Our approach is simple yet powerful: understanding your unique
              needs and delivering software that not only aligns with your
              objectives but also drives your enterprise forward. We work
              collaboratively to create tailored software solutions that
              streamline operations, enhance efficiency, and improve customer
              engagement.
            </p>
            <p>
              With a focus on innovation and the latest industry trends, we
              empower Florida enterprises to remain competitive in an
              ever-changing digital world.Our solutions are designed to be
              agile, scalable, and adaptable to meet the evolving needs of your
              business, ensuring you stay ahead of the curve.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
